export default __webpack_public_path__ + "static/media/roles_3.f40c7b4e.png";